module.exports = __webpack_public_path__ + "static/img/bg-jgpt-case-expressway.528a0cfd.png";